export type TestAccountDefinition = {
  label: string;
  email: string;
  roleCode: string;
  orgCode?: string;
  description: string;
  color: string;
  icon: string;
  password: string;
  visibleOnLogin?: boolean;
};

export const TEST_ACCOUNTS: TestAccountDefinition[] = [
  {
    label: "Mariam Adjanohoun",
    email: "cabinet@presidence.bj",
    roleCode: "BADGE_SUPERVISOR",
    description: "Validation finale des demandes de badges.",
    color: "border-red-500/50 bg-red-500/5",
    icon: "ShieldCheck",
    password: "Password0",
    visibleOnLogin: true,
  },
  {
    label: "Armel Hounkpatin",
    email: "badge-office@presidence.bj",
    roleCode: "BADGE_OPERATOR",
    description: "Prépare, remet et gère les accès des badges.",
    color: "border-amber-500/50 bg-amber-500/5",
    icon: "ClipboardCheck",
    password: "Password0",
    visibleOnLogin: true,
  },
  {
    label: "Clarisse Zinsou",
    email: "supervisor@presidence.bj",
    roleCode: "INSTITUTION_SUPERVISOR",
    orgCode: "PRES",
    description: "Valide les demandes de badges de son organisation.",
    color: "border-blue-500/50 bg-blue-500/5",
    icon: "Users",
    password: "Password0",
    visibleOnLogin: true,
  },
  {
    label: "Kossi Dossou",
    email: "operator@presidence.bj",
    roleCode: "INSTITUTION_OPERATOR",
    orgCode: "PRES",
    description:
      "Gère les personnes et demandes de badges de son organisation.",
    color: "border-sky-500/50 bg-sky-500/5",
    icon: "UserPlus",
    password: "Password0",
    visibleOnLogin: true,
  },
  {
    label: "Hortense Gandonou",
    email: "sentinel@presidence.bj",
    roleCode: "SENTINEL",
    description: "Accueil et supervision des points de contrôle.",
    color: "border-emerald-500/50 bg-emerald-500/5",
    icon: "BadgeCheck",
    password: "Password0",
    visibleOnLogin: true,
  },
  {
    label: "Ruth Houssou",
    email: "sentinel2@presidence.bj",
    roleCode: "SENTINEL",
    description: "Sentinelle affectable aux checkpoints et terminaux terrain.",
    color: "border-emerald-500/50 bg-emerald-500/5",
    icon: "BadgeCheck",
    password: "Password0",
    visibleOnLogin: false,
  },
  {
    label: "Idrissou Amoussou",
    email: "sentinel3@presidence.bj",
    roleCode: "SENTINEL",
    description: "Sentinelle affectable aux checkpoints et terminaux terrain.",
    color: "border-emerald-500/50 bg-emerald-500/5",
    icon: "BadgeCheck",
    password: "Password0",
    visibleOnLogin: false,
  },
  {
    label: "Nadine Dovonou",
    email: "sentinel4@presidence.bj",
    roleCode: "SENTINEL",
    description: "Sentinelle affectable aux checkpoints et terminaux terrain.",
    color: "border-emerald-500/50 bg-emerald-500/5",
    icon: "BadgeCheck",
    password: "Password0",
    visibleOnLogin: false,
  },
  {
    label: "Blaise Kiki",
    email: "sentinel5@presidence.bj",
    roleCode: "SENTINEL",
    description: "Sentinelle affectable aux checkpoints et terminaux terrain.",
    color: "border-emerald-500/50 bg-emerald-500/5",
    icon: "BadgeCheck",
    password: "Password0",
    visibleOnLogin: false,
  },
  {
    label: "Estelle Soglo",
    email: "sentinel6@presidence.bj",
    roleCode: "SENTINEL",
    description: "Sentinelle affectable aux checkpoints et terminaux terrain.",
    color: "border-emerald-500/50 bg-emerald-500/5",
    icon: "BadgeCheck",
    password: "Password0",
    visibleOnLogin: false,
  },
  {
    label: "Ulrich Yedomon",
    email: "sentinel7@presidence.bj",
    roleCode: "SENTINEL",
    description: "Sentinelle affectable aux checkpoints et terminaux terrain.",
    color: "border-emerald-500/50 bg-emerald-500/5",
    icon: "BadgeCheck",
    password: "Password0",
    visibleOnLogin: false,
  },
  {
    label: "Grâce Fanou",
    email: "sentinel8@presidence.bj",
    roleCode: "SENTINEL",
    description: "Sentinelle affectable aux checkpoints et terminaux terrain.",
    color: "border-emerald-500/50 bg-emerald-500/5",
    icon: "BadgeCheck",
    password: "Password0",
    visibleOnLogin: false,
  },
  {
    label: "Pascal Houngbo",
    email: "ops-global@presidence.bj",
    roleCode: "MILITARY_SUPERVISOR",
    description:
      "Superviseur militaire chargé de la surveillance centrale et des badges.",
    color: "border-violet-500/50 bg-violet-500/5",
    icon: "Radar",
    password: "Password0",
    visibleOnLogin: true,
  },
  {
    label: "Awa Quenum",
    email: "employee@presidence.bj",
    roleCode: "EMPLOYEE",
    orgCode: "PRES",
    description: "Personnel de la Présidence gérant ses visites.",
    color: "border-green-500/50 bg-green-500/5",
    icon: "Briefcase",
    password: "Password0",
    visibleOnLogin: true,
  },
  {
    label: "Mireille Akplogan",
    email: "dsi@presidence.bj",
    roleCode: "DSI",
    description: "Équipe technique gérant les référentiels.",
    color: "border-cyan-500/50 bg-cyan-500/5",
    icon: "Cpu",
    password: "Password0",
    visibleOnLogin: true,
  },
];
